__turbopack_context__.v({
  "bar": "StickyCartBar-module-scss-module__eN8jeq__bar",
  "bar__cta": "StickyCartBar-module-scss-module__eN8jeq__bar__cta",
  "bar__info": "StickyCartBar-module-scss-module__eN8jeq__bar__info",
  "bar__inner": "StickyCartBar-module-scss-module__eN8jeq__bar__inner",
  "bar__price": "StickyCartBar-module-scss-module__eN8jeq__bar__price",
  "bar__title": "StickyCartBar-module-scss-module__eN8jeq__bar__title",
});
